import { type FC, type ReactNode } from "react";

import { type SubmissionQuota, SubmissionQuotaSeverity } from "../../models/SubmissionQuota";

import { SubmissionQuotaContext } from "./SubmissionQuotaContext";
import {
    AlmostAtLimit,
    LensPlusRemaining,
    LensPlusUnavailable,
    NonLensPlusRemaining,
    NonLensPlusUnavailable,
    RunningLow,
} from "./messages.generated";

const severityContent: Record<SubmissionQuotaSeverity, ReactNode | null> = {
    [SubmissionQuotaSeverity.Normal]: null,
    [SubmissionQuotaSeverity.Warning]: <RunningLow />,
    [SubmissionQuotaSeverity.Urgent]: <AlmostAtLimit />,
    [SubmissionQuotaSeverity.Exhausted]: null,
};

export const SubmissionQuotaRemainingText: FC<{
    context: SubmissionQuotaContext;
    quota: SubmissionQuota;
}> = ({ context, quota }) => {
    if (quota.severity === SubmissionQuotaSeverity.Exhausted) {
        return context === SubmissionQuotaContext.LensPlus ? <LensPlusUnavailable /> : <NonLensPlusUnavailable />;
    }

    const status = severityContent[quota.severity];

    return (
        <>
            {context === SubmissionQuotaContext.LensPlus ? (
                <LensPlusRemaining remaining={quota.remaining} />
            ) : (
                <NonLensPlusRemaining remaining={quota.remaining} />
            )}
            {status ? <> — {status}</> : null}
        </>
    );
};
